import React from 'react';

interface EmptyStateProps {
  onClear: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onClear }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center gap-2 w-full">
      <p className="text-sm font-medium text-cat-text-muted font-sans">No events match this filter.</p>
      <button onClick={onClear} className="text-xs text-cat-accent uppercase font-bold hover:underline">
        Clear Filters →
      </button>
    </div>
  );
};